import * as React from 'react';

import { CardStatusTag } from '@coursera/cds-core';

import { getGenAiBadges } from 'bundles/product-card/hooks/useGenAiBadges';

import _t from 'i18n!nls/product-card';

export const getProductCardStatusTags = (isNew?: boolean, isCostFree?: boolean, slug?: string) => {
  const { badges: genAiBadges, names } = getGenAiBadges(slug);
  const tags = [];
  const tagNames = [];

  if (isNew) {
    tags.push(<CardStatusTag key="new">{_t('New')}</CardStatusTag>);
    tagNames.push('New');
  }
  if (isCostFree) {
    tags.push(<CardStatusTag key="free">{_t('Free')}</CardStatusTag>);
    tagNames.push('Free');
  }
  tags.push(...genAiBadges);
  tagNames.push(...names);

  return { tags, tagNames };
};
